module.exports = __webpack_public_path__ + "img/3-4.f58e1817.svg";